(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ga-bridal"]) return;
  try {
    

//swiper script

  $(window).on({
   load: function(){
      $(this).trigger('resize');
    } 
  });

    var swiper = new Swiper( '.relatedproductslider', {
      autoHeight: true, //enable auto height
      spaceBetween: 30,
      slidesPerView: 3,
    
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      
            pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      
     // Responsive breakpoints   
      breakpoints: {  
      // when window width is <= 640px     
      800: {       
         slidesPerView: 2,       
         spaceBetween: 30     
      } ,
       // when window width is <= 480px     
      480: {       
         slidesPerView:1,       
         spaceBetween: 20     
      } 
  
   } 
    }
               
   );
  
  
    var swiper1 = new Swiper('.s1', {
           autoHeight: true,
            spaceBetween: 10,
            slidesPerView: 1,
            pagination: {
            el: '.swiper-pagination',
            clickable: true,
            },
            }); 
  
  
  
    var swiper1 = new Swiper('.qview', {
           autoHeight: true,
            spaceBetween: 10,
            slidesPerView: 1,
      observer: true,
      observeParents: true,
      
            pagination: {
            el: '.swiper-pagination',
            clickable: true,
            },
      
            }); 
  
  
  
  
  var swiper = new Swiper('.bridebtmslide', {
      autoHeight: true, //enable auto height
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ga-faq"]) return;
  try {
    

let ga_card_head 			= document.querySelectorAll('.card-header'),
    ga_card_body			= document.querySelectorAll('.card-body');

ga_card_head.forEach((e,i)=>{
  e.addEventListener('click', (event)=>{
	event.preventDefault();
    let ga_adj_cb_elem		= ga_card_body[i];
	if(!ga_adj_cb_elem.classList.contains('show')){
		ga_adj_cb_elem.classList.add('show');
	} else {
		ga_adj_cb_elem.classList.remove('show');
	}
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ga-our-story"]) return;
  try {
    

        // poster frame click event
        $( document ).on( 'click', '.js-videoPoster', function ( ev ) {
            ev.preventDefault();
            var $poster = $( this );
            var $wrapper = $poster.closest( '.js-videoWrapper' );
            videoPlay( $wrapper );
        } );
        
                // play the targeted video (and hide the poster frame)
        function videoPlay( $wrapper ) {
            var $iframe = $wrapper.find( '.js-videoIframe' );
            var src = $iframe.data( 'src' );
            // hide poster
            $wrapper.addClass( 'videoWrapperActive' );
            if($(window).width() > 767){$('.videoindex .videotext').css('opacity', '0');}
            // add iframe src in, starting the video
            $iframe.attr( 'src', src );
        }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ga-pre-product"]) return;
  try {
    



window.addEventListener("DOMContentLoaded", () => {
    let ga_elems_size = ga__S(".prod__option--button .product-option-item"),
      ga_product_data = ga__S("#ga-product-data>.ga-product-vd"),
      ga_elems_color = ga__S(".prod__option--image .product-option-item"),
      ga_quantity_inc_btn = ga__S(
        ".main-product__block-buy_buttons .quantity-input>.quantity-input__button[data-quantity-selector='increase']",
        0
      ),
      ga_quantity_dec_btn = ga__S(
        ".main-product__block-buy_buttons .quantity-input>.quantity-input__button[data-quantity-selector='decrease']",
        0
      ),
      ga_quantity_input = ga__S(
        ".main-product__block-buy_buttons .quantity-input>.quantity-input__element",
        0
      ),
      ga_sticky_cart_quantity_input = ga__S(
        ".prod__sticky-atc .quantity-input>.quantity-input__element",
        0
      ),
      ga_default_variant_id = ga__S("#ga-dv-id", 0).dataset.gaDid,
      ga_product_desc_elem =ga__S('.main-product__blocks .product__description>p', 0),
      ga_product_desc =ga__S('.main-product__blocks .product__description>p', 0).textContent;
  
    const ga_quantity_btn_array = [ga_quantity_inc_btn, ga_quantity_dec_btn];
  
    ga_quantity_btn_array.forEach((e, i) => {
      e.addEventListener("click", () => {
        let value = Number(ga_quantity_input.value);
        if (i == 0) {
          value++;
        }
        if (i == 1) {
          value--;
        }
        ga_sticky_cart_quantity_input.value = value;
      });
    });
  
    let ga_default_size = ga__S(
      `#ga-product-data>[data-ga-id="${ga_default_variant_id}"]`,
      0
    ).dataset.gaTitle.split("-")[1];
  
    ga_hideUnavailableColors(ga_default_size);
  
    ga_elems_size.forEach((elem) => {
      elem.addEventListener("click", () => {
        ga_elems_color.forEach((e) => {
          e.classList.remove("ga-soldout-opt");
        });
        let selected_size = elem.dataset.value;
        ga_hideUnavailableColors(selected_size);
      });
    });
  
  
    // ga_elems_color.forEach((e)=>{
  //   e.addEventListener('click', ()=>{
  //     let selected_color = e.dataset.value.toLowerCase(),
  //       prev_selected_color = ga__S(".prod__option--image .product-option-item[data-selected='true']", 0).dataset.value.toLowerCase(),
  //       string = ga_product_desc.toLowerCase();
  //     if(string.includes(prev_selected_color)){
  //       ga_product_desc = ga_product_desc.replaceAll(new RegExp(`${prev_selected_color}`, 'ig'), selected_color);
  //       ga_product_desc_elem.textContent = ga_product_desc;
  //     }
  //   });
  // });
  
    function ga_hideUnavailableColors(selected_size) {
      ga_product_data.forEach((e) => {
        if (e.dataset.gaTitle.includes(selected_size)) {
          if (e.dataset.gaAvail != "true") {
            let ga_unavail_color = e.dataset.gaTitle.split("-")[0],
              elem = ga__S(
                `.prod__option--image .product-option-item[data-value="${ga_unavail_color}"]`,
                0
              );
            elem.classList.add("ga-soldout-opt");
          }
        }
      });
    }
  
    function ga__S(selector, all = 1) {
      if (all) {
        return document.querySelectorAll(selector);
      } else {
        return document.querySelector(selector);
      }
    }
  });




  } catch(e) { console.error(e); }
})();
})();
